var map = {
	"./Accordion.svg": 735,
	"./Breadcrumb.svg": 736,
	"./Button.svg": 737,
	"./Checkbox.svg": 738,
	"./Code snippet.svg": 739,
	"./Content switcher.svg": 740,
	"./Data table.svg": 741,
	"./Date picker.svg": 742,
	"./Dropdown.svg": 743,
	"./File uploader.svg": 744,
	"./Form.svg": 745,
	"./Inline loading.svg": 746,
	"./Link.svg": 747,
	"./List.svg": 748,
	"./Loading.svg": 749,
	"./Modal.svg": 750,
	"./Multiselect.svg": 751,
	"./NoImage.svg": 392,
	"./Notification.svg": 752,
	"./Number input.svg": 753,
	"./Overflow menu.svg": 754,
	"./Pagination.svg": 755,
	"./Progress indicator.svg": 756,
	"./Radio button.svg": 757,
	"./Search.svg": 758,
	"./Select.svg": 759,
	"./Slider.svg": 760,
	"./Structured list.svg": 761,
	"./Tabs.svg": 762,
	"./Tag.svg": 763,
	"./Text input.svg": 764,
	"./Tile.svg": 765,
	"./Toggle.svg": 766,
	"./Tooltip.svg": 767,
	"./UI shell.svg": 768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 734;